import { Component } from '@angular/core';

@Component({
  selector: 'app-products-page',
  templateUrl: './products-page.component.html',
  styleUrls: ['./products-page.component.css'],
  standalone:false
})
export class ProductsPageComponent {
  activeTab: 'catalog' | 'pending' = 'catalog';
}
